export const BADGE_TYPE = Object.freeze({
  deactivated: 'bg-color-danger-light',
  preRegistered: 'bg-color-alert-light',
  activated: 'bg-color-success-light',
  fallback: 'bg-color-danger-light',
});

export default BADGE_TYPE;
